module.exports = __webpack_public_path__ + "img/sp_article_12.c65cf20d.jpg";